import React, { useState } from 'react';
import '../styles/DownloadIcon.css';

const DownloadIcon = ({ onExport, data, filename = 'export', chartRef = null }) => {
  const [showModal, setShowModal] = useState(false);

  const handleIconClick = () => {
    setShowModal(true);
  };

  const handleFormatSelection = async (format) => {
    setShowModal(false);

    // Get the canvas element from the chart reference
    let chartCanvas = null;
    if (chartRef && chartRef.current) {
      chartCanvas = chartRef.current.canvas;
    }

    await onExport(format, data, filename, chartCanvas);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <>
      {/* Download Icon */}
      <div className="download-icon-container" onClick={handleIconClick} title="Download Graph Data">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          className="download-icon"
        >
          <path d="M12 2C11.45 2 11 2.45 11 3V12.5L8.5 10L7.09 11.41L12 16.32L16.91 11.41L15.5 10L13 12.5V3C13 2.45 12.55 2 12 2ZM5 18C5 18.55 5.45 19 6 19H18C18.55 19 19 18.55 19 18V16H21V18C21 19.66 19.66 21 18 21H6C4.34 21 3 19.66 3 18V16H5V18Z" />
        </svg>
      </div>

      {/* Format Selection Modal */}
      {showModal && (
        <div className="download-modal-overlay" onClick={handleCloseModal}>
          <div className="download-modal" onClick={(e) => e.stopPropagation()}>
            <div className="download-modal-header">
              <h3>Select Export Format</h3>
              <button className="download-modal-close" onClick={handleCloseModal}>
                &times;
              </button>
            </div>
            <div className="download-modal-body">
              <p>Choose the format for exporting the graph data:</p>
              <div className="download-format-options">
                <button
                  className="download-format-btn download-format-xlsx"
                  onClick={() => handleFormatSelection('xlsx')}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2ZM18 20H6V4H13V9H18V20ZM8 15.5L10 18L8 20.5H9.5L11 18.5L12.5 20.5H14L12 18L14 15.5H12.5L11 17.5L9.5 15.5H8Z" />
                  </svg>
                  <span>.XLSX</span>
                  <p>Formatted report with charts and statistics</p>
                </button>
                <button
                  className="download-format-btn download-format-csv"
                  onClick={() => handleFormatSelection('csv')}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2ZM18 20H6V4H13V9H18V20ZM10 19H8V17H10V19ZM10 16H8V14H10V16ZM10 13H8V11H10V13ZM16 19H12V17H16V19ZM16 16H12V14H16V16ZM16 13H12V11H16V13Z" />
                  </svg>
                  <span>CSV</span>
                  <p>Detailed raw data with comprehensive structure</p>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DownloadIcon;
